export default "__VITE_ASSET__DhyKdyz0__"